import Content from './content';
import {CountUp} from 'countup.js';

/**
 * Stats content element.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class Stats extends Content {
  /**
   * Contains the numbers to animate.
   *
   * @type {NodeListOf<HTMLElement>}
   * @private
   */
  private numbers: NodeListOf<HTMLElement>;

  /**
   * Contains the countUp.js instances.
   *
   * @type {CountUp[]}
   * @private
   */
  private countUpInstances: CountUp[] = [];

  /**
   * Whether the countUp.js animation has already started or not.
   *
   * @type {boolean}
   * @private
   */
  private countUpStarted: boolean = false;


  constructor(container: HTMLElement) {
    super(container);
    this.numbers = this.container.querySelectorAll('.number');

    this.initializeCountUp();
    this.startOnScrolling();

    window.addEventListener('scroll', () => {
      this.startOnScrolling();
    }, {'capture': false, 'passive': true});

    this.readyEvent.dispatch();
  }


  /**
   * Initializes the countUp.js animation.
   *
   * @returns {void}
   * @private
   */
  private initializeCountUp(): void {
    this.numbers.forEach(item => {
      const value = parseInt(item.innerHTML);
      const countUp = new CountUp(item, value);
      this.countUpInstances.push(countUp);
    });
  }


  /**
   * Starts the counter when scrolling past the element.
   *
   * @returns {void}
   * @private
   */
  private startOnScrolling(): void {
    if (this.countUpStarted) {
      return;
    }

    if (window.pageYOffset + window.innerHeight > this.container.getBoundingClientRect().top + window.pageYOffset) {
      for (const countUp of this.countUpInstances) {
        countUp.start();
      }

      this.countUpStarted = true;
    }
  }
}
